module.exports = __webpack_public_path__ + "static/img/image8.a28235a2.png";